import { useState, useEffect } from 'react'
import { Menu, X } from 'lucide-react'

const navItems = [
  { href: '#sobre', label: 'Sobre' },
  { href: '#documentos', label: 'Documentos' },
  { href: '#timeline', label: 'Fases' },
  { href: '#faq', label: 'FAQ' },
  { href: '#galeria', label: 'Galeria' },
  { href: '#contato', label: 'Fale Conosco' },
]

export function Navbar() {
  const [isOpen, setIsOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const [activeSection, setActiveSection] = useState('')

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60)

      const sections = navItems.map((item) => item.href.replace('#', ''))
      let current = ''
      for (const section of sections) {
        const element = document.getElementById(section)
        if (element && element.getBoundingClientRect().top <= 120) {
          current = section
        }
      }
      setActiveSection(current)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToSection = (href: string) => {
    setIsOpen(false)
    const element = document.querySelector(href)
    if (element) {
      const offset = 80
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.scrollY - offset
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' })
    }
  }

  return (
    <nav
      className={`sticky top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-md border-b border-gray-100'
          : 'bg-white shadow-sm'
      }`}
      role="navigation"
      aria-label="Navegação principal"
    >
      <div className="container flex items-center justify-between py-3">
        <a
          href="#hero"
          onClick={(e) => {
            e.preventDefault()
            scrollToSection('#hero')
          }}
          className="flex items-center gap-2 group"
          aria-label="Voltar ao topo - CGPP Porto Velho"
        >
          <div className="w-9 h-9 bg-[#51A64D] rounded-lg flex items-center justify-center text-white font-bold text-sm font-serif shadow-sm">
            CP
          </div>
          <div className="hidden sm:block">
            <div className="font-serif font-bold text-[#51A64D] text-sm leading-tight">
              CGPP Porto Velho
            </div>
            <div className="text-[10px] text-gray-500 leading-tight">Concessão de Parques Urbanos</div>
          </div>
        </a>

        <div className="hidden lg:flex items-center gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => {
                e.preventDefault()
                scrollToSection(item.href)
              }}
              className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
                activeSection === item.href.replace('#', '')
                  ? 'text-[#51A64D] bg-green-50'
                  : 'text-gray-600 hover:text-[#51A64D] hover:bg-gray-50'
              }`}
            >
              {item.label}
            </a>
          ))}
          <a
            href="#documentos"
            onClick={(e) => {
              e.preventDefault()
              scrollToSection('#documentos')
            }}
            className="ml-2 px-4 py-2 bg-[#51A64D] text-white text-sm font-semibold rounded-lg hover:bg-[#458f3f] transition-colors shadow-sm"
          >
            Documentos
          </a>
        </div>

        <button
          onClick={() => setIsOpen(!isOpen)}
          className="lg:hidden p-2 rounded-md hover:bg-gray-100 transition-colors"
          aria-label={isOpen ? 'Fechar menu' : 'Abrir menu'}
          aria-expanded={isOpen}
        >
          {isOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {isOpen && (
        <div className="lg:hidden border-t border-gray-100 bg-white pb-4">
          <div className="container flex flex-col gap-1 pt-2">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault()
                  scrollToSection(item.href)
                }}
                className={`px-3 py-2.5 rounded-md text-sm font-medium transition-colors ${
                  activeSection === item.href.replace('#', '')
                    ? 'text-[#51A64D] bg-green-50'
                    : 'text-gray-600 hover:text-[#51A64D] hover:bg-gray-50'
                }`}
              >
                {item.label}
              </a>
            ))}
            <a
              href="#documentos"
              onClick={(e) => {
                e.preventDefault()
                scrollToSection('#documentos')
              }}
              className="mt-2 px-4 py-2.5 bg-[#51A64D] text-white text-sm font-semibold rounded-lg hover:bg-[#458f3f] transition-colors text-center"
            >
              Documentos e Anexos
            </a>
          </div>
        </div>
      )}
    </nav>
  )
}